<template lang="pug">
  v-container(fluid)
    h1 Tithes
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped></style>
